import { call, put, all, takeEvery } from "redux-saga/effects";

import { tourDetailActions } from '../slice/tourDetailSlice'
import { getTourDetailApi } from 'services/tourServices'
import { createFavoriteApi, removeFavoriteApi } from 'services/favoriteServices'
import ShowToast from "utils/ShowToast";


function* handleGetTour(action) {
    try {
        const res = yield call(getTourDetailApi, action.payload.slug, action.payload.account)
        if (res.status === 200) {
            const response = res.data
            if (response.success === true) {
                yield put(tourDetailActions.getTourSuccess({ data: response.data[0] }))
            }
            else {
                yield put(tourDetailActions.getTourFailed())
            }
        }
        else {
            yield put(tourDetailActions.getTourFailed())
        }
    } catch (error) {
        yield put(tourDetailActions.getTourFailed())
    }
}

function* handleCreateFavorite(action) {
    try {
        const res = yield call(createFavoriteApi, action.payload.data)
        if (res.status === 200) {
            const response = res.data
            if (response.success === true) {
                yield put(tourDetailActions.addFavoriteSuccess({ data: response.data.id }))
            }
            else {
                yield put(tourDetailActions.addFavoriteFailed())
                ShowToast('error', 'Thêm vào danh sách yêu thích thất bại, vui lòng thử lại sau')
            }
        }
        else {
            yield put(tourDetailActions.addFavoriteFailed())
            ShowToast('error', 'Thêm vào danh sách yêu thích thất bại, vui lòng thử lại sau')
        }
    } catch (error) {
        yield put(tourDetailActions.addFavoriteFailed())
        ShowToast('error', 'Thêm vào danh sách yêu thích thất bại, vui lòng thử lại sau')
    }
}
function* handleRemoveFavorite(action) {
    try {
        const res = yield call(removeFavoriteApi, action.payload)
        if (res.status === 200) {
            const response = res.data
            if (response.success === true) {
                yield put(tourDetailActions.removeFavoriteSuccess())
            }
            else {
                yield put(tourDetailActions.removeFavoriteFailed())
                ShowToast('error', 'Xóa khỏi danh sách yêu thích thất bại, vui lòng thử lại sau')
            }
        }
        else {
            yield put(tourDetailActions.removeFavoriteFailed())
            ShowToast('error', 'Xóa khỏi danh sách yêu thích thất bại, vui lòng thử lại sau')
        }
    } catch (error) {
        yield put(tourDetailActions.removeFavoriteFailed())
        ShowToast('error', 'Xóa khỏi danh sách yêu thích thất bại, vui lòng thử lại sau')
    }
}


export default function* tourDetailSaga() {
    yield all(
        [
            takeEvery(tourDetailActions.getTour.type, handleGetTour),
            takeEvery(tourDetailActions.addFavorite.type, handleCreateFavorite),
            takeEvery(tourDetailActions.removeFavorite.type, handleRemoveFavorite),
        ]
    )
}
